import { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
	children: ReactNode;
	fallback: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	public static getDerivedStateFromError(_error: any) {
		// if this function is called, an error has occurred, so toggle error true
		return { hasError: true };
	}

	public state: ErrorBoundaryState = {
		hasError: false,
	};

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		console.error('Uncaught error:', error, errorInfo);
	}

	public render() {
		if (this.state.hasError) {
			return this.props.fallback;
		} else {
			// the errorboundary is wrapping the normal children components, therefore if there is no error, render the children
			return this.props.children;
		}
	}
}

export default ErrorBoundary;
